import Help from './Help.vue'

export default Help
